/*
         * @ngdoc function
         * @name ePay.Model:Session_PaymentOptionsModel
         * @description
         * Model
         */
import { Session_PaymentModel } from './Session_PaymentModel';

export class Session_PaymentOptionsModel {
	payment: Session_PaymentModel[];

	constructor(
		payment?: Session_PaymentModel[]
	) {
		this.payment = payment || [];
	}
}
